const viewMode = Object.freeze({
  SHOW: Symbol('show'),
  EDIT: Symbol('edit'),
  PRINT: Symbol('print')
})

export default viewMode
